import {Container, Theme} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {Redirect, Route, Switch} from "react-router-dom";
import React, {lazy} from "react";
import ReactResizeDetector from "react-resize-detector";
import ManagerDispositionMainViewQueryRenderer
    from "@/Domains/DispositionManagement/QueryRenderer/ManagerDispositionMainViewQueryRenderer";
import {RootStateOrAny, useSelector} from "react-redux";
import {getLocale, selectSidebarIsOpen} from "@/Redux/App/AppReducer";
import {DRAWER_WIDTH, DRAWER_WIDTH_CLOSED,} from "@/Components/Sidebar/Constants";
import LoadingElement from "@/Components/Loading/LoadingElement";
import {useTextSearchV2} from "@/Utils/FeatureFlags";

const SalutationSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Salutation/SalutationSearch/QueryRenderer/SalutationSearchMainQueryRenderer"
            )
);

const VouchercodeMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Vouchercode/Voucher/QueryRenderer/VouchercodeMainQueryRenderer"
            )
);

const ManufacturerSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Manufacturer/ManufacturerSearch/QueryRenderer/ManufacturerSearchMainQueryRenderer"
            )
);

const VehicleTypeSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/VehicleType/VehicleTypeSearch/QueryRenderer/VehicleTypeSearchMainQueryRenderer"
            )
);

const PictogramSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/PictogramManagement/PictogramSearch/QueryRenderer/PictogramSearchMainQueryRenderer"
            )
);
const DamageTypeSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/DamageType/DamageTypeSearch/QueryRenderer/DamageTypeSearchMainQueryRenderer"
            )
);
const StationSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/StationManagement/StationSearch/QueryRenderer/StationSearchMainQueryRenderer"
            )
);
const ManagerTranslationMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/TenantManagement/QueryRenderer/ManagerTranslationMainQueryRenderer"
            )
);
const BookingMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/BookingManagement/Booking/Shared/QueryRenderer/BookingMainQueryRenderer"
            )
);
const InvoiceMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/InvoiceManagement/Invoice/QueryRenderer/InvoiceMainQueryRenderer"
            )
);
const VehicleMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/VehicleManagement/Vehicle/QueryRenderer/VehicleMainQueryRenderer"
            )
);
const CustomerMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/CustomerManagement/Customer/QueryRenderer/CustomerMainQueryRenderer"
            )
);
const SupplierMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/CustomerManagement/Supplier/QueryRenderer/SupplierMainQueryRenderer"
            )
);
const TransferDriverMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/CustomerManagement/TransferDriver/QueryRenderer/TransferDriverMainQueryRenderer"
            )
);
const RateSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Rate/RateSearch/QueryRenderer/RateSearchMainQueryRenderer"
            )
);
const EmissionClassSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/EmissionClass/EmissionClassSearch/QueryRenderer/EmissionClassSearchMainQueryRenderer"
            )
);
const RateCategorySearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/RateCategory/RateCategorySearch/QueryRenderer/RateCategorySearchMainQueryRenderer"
            )
);
const ManagerMandantQueryRenderer = lazy(
    () =>
        import(
            "../Domains/TenantManagement/QueryRenderer/ManagerMandantQueryRenderer"
            )
);
const PaymentMethodSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/PaymentMethod/PaymentMethodSearch/QueryRenderer/PaymentMethodSearchMainQueryRenderer"
            )
);
const RateUnitSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/RateUnit/UnitSearch/QueryRenderer/RateUnitSearchMainQueryRenderer"
            )
);
const VehicleInventorySearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/VehicleInventory/VehicleInventorySearch/QueryRenderer/VehicleInventorySearchMainQueryRenderer"
            )
);
const FieldConfigurationSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/FieldConfiguration/FieldConfigurationSearch/QueryRenderer/FieldConfigurationSearchMainQueryRenderer"
            )
);


const ManagerDispositionReservationLogViewQueryRenderer = lazy(
    () =>
        import(
            "../Domains/DispositionManagement/QueryRenderer/ManagerDispositionReservationLogViewQueryRenderer"
            )
);
const ConfigurationDashboardMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Dashboard/QueryRenderer/ConfigurationDashboardMainQueryRenderer"
            )
);
const ParameterSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Parameter/ParameterSearch/QueryRenderer/ParameterSearchMainQueryRenderer"
            )
);
const TextSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Text/TextSearch/QueryRenderer/TextSearchMainQueryRenderer"
            )
);
const TextSearchV2Screen = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Text/TextSearchV2/TextSearchV2Screen"
            )
);
const VehicleGroupSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/VehicleManagement/VehicleGroupSearch/QueryRenderer/VehicleGroupSearchMainQueryRenderer"
            )
);
const UserSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/UserManagement/UserSearch/QueryRenderer/UserSearchMainQueryRenderer"
            )
);
const BranchSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Branch/BranchSearch/QueryRenderer/BranchSearchMainQueryRenderer"
            )
);
const CustomerSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/CustomerManagement/CustomerSearch/QueryRenderer/CustomerSearchMainQueryRenderer"
            )
);
const SupplierSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/CustomerManagement/SupplierSearch/QueryRenderer/SupplierSearchMainQueryRenderer"
            )
);
const TransferDriverSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/CustomerManagement/TransferDriverSearch/QueryRenderer/TransferDriverSearchMainQueryRenderer"
            )
);
const RegionSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Region/RegionSearch/QueryRenderer/RegionSearchMainQueryRenderer"
            )
);
const InvoiceSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/InvoiceManagement/InvoiceSearch/QueryRenderer/InvoiceSearchMainQueryRenderer"
            )
);
const BookingSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/BookingManagement/BookingSearch/QueryRenderer/BookingSearchMainQueryRenderer"
            )
);
const AccountingBookMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/PaymentManagement/QueryRenderer/AccountingBookMainQueryRenderer"
            )
);
const ManagerQueryQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ReportingManagement/QueryRenderer/ManagerQueryQueryRenderer"
            )
);
const VehicleSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/VehicleManagement/VehicleSearch/QueryRenderer/VehicleSearchMainQueryRenderer"
            )
);
const HolidaySearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Holiday/HolidaySearch/QueryRenderer/HolidaySearchMainQueryRenderer"
            )
);
const VehicleGroupMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/VehicleManagement/VehicleGroup/QueryRenderer/VehicleGroupMainQueryRenderer"
            )
);
const StationMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/StationManagement/Station/QueryRenderer/StationMainQueryRenderer"
            )
);

const UserMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/UserManagement/User/QueryRenderer/UserMainQueryRenderer"
            )
);

const OfferSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/OfferManagement/OfferSearch/QueryRenderer/OfferSearchMainQueryRenderer"
            )
);
const OriginSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Origin/OriginSearch/QueryRenderer/OriginSearchMainQueryRenderer"
            )
);

const ManagerDispositionVehicleLogViewQueryRenderer = lazy(
    () =>
        import(
            "../Domains/DispositionManagement/QueryRenderer/ManagerDispositionVehicleLogViewQueryRenderer"

            )
);


const ManagerColorsMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Colors/Colors/QueryRenderer/ManagerColorsMainQueryRenderer"
            )
);
const CountrySearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Country/CountrySearch/QueryRenderer/CountrySearchMainQueryRenderer"
            )
);

const RateMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Rate/Rate/QueryRenderer/RateMainQueryRenderer"
            )
);

const PricelistSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Pricelist/PricelistSearch/QueryRenderer/PricelistSearchMainQueryRenderer"
            )
);

const OfferMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/OfferManagement/Offer/QueryRenderer/OfferMainQueryRenderer"
            )
);

const ORMOfferSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/ORMOffer/ORMOfferSearch/QueryRenderer/ORMOfferSearchMainQueryRenderer"
            )
);

const GroupAttributeSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/GroupAttribute/GroupAttributeSearch/QueryRenderer/GroupAttributeSearchMainQueryRenderer"
            )
);

const MediaSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Media/MediaSearch/QueryRenderer/MediaSearchMainQueryRenderer"
            )
);
const OwnerCodeSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/OwnerCode/OwnerCodeSearch/QueryRenderer/OwnerCodeSearchMainQueryRenderer"
            )
);
const ProtocolRelationSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/ProtocolRelation/ProtocolRelationSearch/QueryRenderer/ProtocolRelationSearchMainQueryRenderer"
            )
);

const CarTypeSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/CarType/CarTypeSearch/QueryRenderer/CarTypeSearchMainQueryRenderer"
            )
);
const CategorySearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/Category/CategorySearch/QueryRenderer/CategorySearchMainQueryRenderer"
            )
);
const CameraViewSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/CameraView/CameraViewSearch/QueryRenderer/CameraViewSearchMainQueryRenderer"
            )
);
const ProtocolTypeSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/ProtocolType/ProtocolTypeSearch/QueryRenderer/ProtocolTypeSearchMainQueryRenderer"
            )
);
const ProtocolOptionsSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/ProtocolOptions/ProtocolOptionsSearch/QueryRenderer/ProtocolOptionsSearchMainQueryRenderer"
            )
);


const DriverSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/CustomerManagement/DriverSearch/QueryRenderer/DriverSearchMainQueryRenderer"
            )
);

const ProtocolGroupSearchMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/ProtocolGroup/ProtocolGroupSearch/QueryRenderer/ProtocolGroupSearchMainQueryRenderer"
            )
);

const DriverMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/CustomerManagement/Driver/QueryRenderer/DriverMainQueryRenderer"
            )
);

const PaymentProviderMainQueryRenderer = lazy(
    () =>
        import(
            "../Domains/ConfigurationManagement/PaymentProvider/PaymentProvider/QueryRenderer/PaymentProviderMainQueryRenderer"
            )
);

const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        "&.MuiContainer-root": {
            position: "absolute",
            maxWidth: "none",
            width: "100%",
            top: 0,
            bottom: 0,
            //maxWidth: '100%',
            padding: "6px",
            margin: 0,
        },
    },
}));

export default function ManagerRoutes() {
    const {classes} = useStyles();
    const sidebarIsOpen = useSelector((state) =>
        selectSidebarIsOpen(state as RootStateOrAny)
    );
    const language = useSelector((state) => getLocale());
    const textSearchV2Enabled = useTextSearchV2();

    const renderRoutes = (width: number | undefined): JSX.Element => {
        if (width == undefined) {
            width = 0;
        }
        // @ts-ignore
        return (
            <Switch>
                <Route path="/manager/disposition" exact={true}>
                    <ManagerDispositionMainViewQueryRenderer
                        width={width}
                        isLoggedIn={true}
                    />
                </Route>
                <Route path="/manager/log">
                    <ManagerDispositionVehicleLogViewQueryRenderer
                        width={width}
                        isLoggedIn={true}/>
                </Route>
                <Route path="/manager/disposition/reservations" exact={true}>
                    <ManagerDispositionReservationLogViewQueryRenderer
                        width={width}
                        isLoggedIn={true}
                    />
                </Route>

                <Route path="/manager/customers">
                    <CustomerSearchMainQueryRenderer
                        isOpenAsPopup={false}
                        predefinedCustomerId={null}
                        handleClose={() => {
                        }}
                        preselectedCategory={"A"}
                        disableAddressType={false}
                    />
                </Route>

                <Route path="/manager/customer/:customerId/show">
                    <CustomerMainQueryRenderer
                        isOpenAsPopup={false}
                        predefinedCustomerId={null}
                    />
                </Route>
                <Route path="/manager/configuration/origins">
                    <OriginSearchMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={() => {
                        }}
                    />
                </Route>

                <Route path="/manager/suppliers">
                    <SupplierSearchMainQueryRenderer
                        isOpenAsPopup={false}
                        predefinedCustomerId={null}
                        handleClose={() => {
                        }}
                        preselectedCategory={"A"}
                        disableAddressType={false}
                    />
                </Route>

                <Route path="/manager/configuration/group-attributes">
                    <GroupAttributeSearchMainQueryRenderer
                        isOpenAsPopup={false}
                        predefinedCustomerId={null}
                        handleClose={() => {
                        }}
                        preselectedCategory={"A"}
                        disableAddressType={false}
                    />
                </Route>

                <Route path="/manager/transfer-drivers">
                    <TransferDriverSearchMainQueryRenderer
                        isOpenAsPopup={false}
                        predefinedCustomerId={null}
                        handleClose={() => {
                        }}
                        preselectedCategory={"T"}
                        disableAddressType={true}
                    />
                </Route>

                <Route path="/manager/drivers">
                    <DriverSearchMainQueryRenderer
                        predefinedCustomerId={null}
                        predefinedDriverId={null}
                        handleClose={() => {
                        }}
                        openAsPopup={false}
                    />
                </Route>

                <Route path="/manager/driver/:driverId/show">
                    <DriverMainQueryRenderer
                        driverId={null}
                        customerId={null}
                        handleClose={() => {
                        }}
                        openAsDialog={false}
                    />
                </Route>

                <Route path="/manager/supplier/:customerId/show">
                    <SupplierMainQueryRenderer
                        isOpenAsPopup={false}
                        predefinedCustomerId={null}
                    />
                </Route>

                <Route path="/manager/transfer-driver/:customerId/show">
                    <TransferDriverMainQueryRenderer
                        isOpenAsPopup={false}
                        predefinedCustomerId={null}
                    />
                </Route>

                <Route path={"/manager/reservation/:bookingId/:action"}>
                    <BookingMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={() => {
                        }}
                        action={null}
                        isTransfer={false}
                        predefinedStatus={"reservation"}
                    />
                </Route>

                <Route path={"/manager/contract/:bookingId/:action"}>
                    <BookingMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={() => {
                        }}
                        action={null}
                        isTransfer={false}
                        predefinedStatus={"contract_co"}
                    />
                </Route>

                <Route path={"/manager/transfer/:bookingId/:action"}>
                    <BookingMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={() => {
                        }}
                        action={null}
                        isTransfer={true}
                        predefinedStatus={"transfer_co"}
                    />
                </Route>

                <Route
                    path={"/manager/transfer-reservation/:bookingId/:action"}
                >
                    <BookingMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={() => {
                        }}
                        action={null}
                        isTransfer={true}
                        predefinedStatus={"transfer_res"}
                    />
                </Route>

                <Route path={"/manager/bookings/"}>
                    <BookingSearchMainQueryRenderer
                        isOpenAsPopup={false}
                        predefinedCustomerId={null}
                        predefinedVehicleId={null}
                        handleClose={() => {
                        }}
                    />
                </Route>

                <Route path={"/manager/invoice/:invoiceId/show"}>
                    <InvoiceMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={() => {
                        }}
                    />
                </Route>

                <Route path="/manager/invoices">
                    <InvoiceSearchMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={() => {
                        }}
                        bookingStatus={null}
                    />
                </Route>

                <Route path="/manager/configuration/countries">
                    <CountrySearchMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={() => {
                        }}
                    />
                </Route>


                <Route path="/manager/vehicles">
                    <VehicleSearchMainQueryRenderer
                        predefinedVehicleId={null}
                        isOpenAsPopup={false}
                    />
                </Route>

                <Route path="/manager/vehicle/:vehicleId/show">
                    <VehicleMainQueryRenderer isOpenAsPopup={false}/>
                </Route>

                <Route path="/manager/accounting-book">
                    <AccountingBookMainQueryRenderer/>
                </Route>

                <Route path="/manager/offer/:offerId/show">
                    <OfferMainQueryRenderer isOpenAsPopup={false}/>
                </Route>

                <Route path="/manager/queries">
                    <ManagerQueryQueryRenderer/>
                </Route>

                <Route path="/manager/configuration/rates">
                    <RateSearchMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={() => {
                        }}
                    />
                </Route>
                <Route path="/manager/configuration/emission-classes">
                    <EmissionClassSearchMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={() => {
                        }}
                    />
                </Route>


                <Route path="/manager/configuration/rate/:rateId/:groupId/show">
                    <RateMainQueryRenderer isOpenAsPopup={false}/>
                </Route>
                <Route path="/manager/configuration/salutations">
                    <SalutationSearchMainQueryRenderer isOpenAsPopup={false}/>
                </Route>

                <Route path="/manager/configuration/paymentProvider">
                    <PaymentProviderMainQueryRenderer isOpenAsPopup={false}/>
                </Route>

                <Route path="/manager/configuration/stations">
                    <StationSearchMainQueryRenderer isOpenAsPopup={false}/>
                </Route>
                <Route path="/manager/configuration/categories">
                    <CategorySearchMainQueryRenderer/>
                </Route>

                <Route path="/manager/configuration/branches">
                    <BranchSearchMainQueryRenderer isOpenAsPopup={false}/>
                </Route>
                <Route path="/manager/configuration/station/:stationId/show">
                    <StationMainQueryRenderer isOpenAsPopup={false}/>
                </Route>

                <Route path="/manager/configuration/users">
                    <UserSearchMainQueryRenderer/>
                </Route>

                <Route path="/manager/configuration/rateunits">
                    <RateUnitSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/branches">
                    <BranchSearchMainQueryRenderer
                        isOpenAsPopup={false}/>
                </Route>


                <Route path="/manager/configuration/user/:userId/show">
                    <UserMainQueryRenderer isOpenAsPopup={false}/>
                </Route>

                <Route path="/manager/configuration/vehicle-groups">
                    <VehicleGroupSearchMainQueryRenderer
                        isOpenAsPopup={false}
                    />
                </Route>
                <Route path="/manager/configuration/holidays">
                    <HolidaySearchMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={undefined}/>
                </Route>
                <Route path="/manager/configuration/dispositionregions">
                    <RegionSearchMainQueryRenderer
                        isOpenAsPopup={false}
                    />
                </Route>

                <Route path="/manager/configuration/vehicle-group/:vehicleGroupId/show">
                    <VehicleGroupMainQueryRenderer isOpenAsPopup={false}/>
                </Route>

                <Route path="/manager/configuration/mandant">
                    <ManagerMandantQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/manufacturers">
                    <ManufacturerSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/vehicleTypes">
                    <VehicleTypeSearchMainQueryRenderer/>
                </Route>

                <Route path="/manager/configuration/fieldconfiguration">
                    <FieldConfigurationSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/cameraviews">
                    <CameraViewSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/pictograms">
                    <PictogramSearchMainQueryRenderer
                        handleClose={() => {
                        }}
                        isOpenAsPopup={false}
                    />
                </Route>
                <Route path="/manager/configuration/texts">
                    {/* Variante A der Textverwaltung hinter VITE_USE_TEXTSEARCH_V2.
                        Beide Varianten bleiben verfuegbar und lazy geladen. */}
                    {textSearchV2Enabled ? (
                        <TextSearchV2Screen/>
                    ) : (
                        <TextSearchMainQueryRenderer/>
                    )}
                </Route>
                <Route path="/manager/configuration/translations">
                    <ManagerTranslationMainQueryRenderer
                        prefix={"login"}
                        lang={language}
                    />
                </Route>
                <Route path="/manager/configuration/parameters">
                    <ParameterSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/vehicleInventories">
                    <VehicleInventorySearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/protocolgroups">
                    <ProtocolGroupSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/financial-accounting">
                    <PaymentMethodSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/ratecategories">
                    <RateCategorySearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/colors">
                    <ManagerColorsMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/dashboard">
                    <ConfigurationDashboardMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/vouchercodes">
                    <VouchercodeMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/pricelists">
                    <PricelistSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/damageTypes">
                    <DamageTypeSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/media">
                    <MediaSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/carTypes">
                    <CarTypeSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/ownerCodes">
                    <OwnerCodeSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/protocoltypes">
                    <ProtocolTypeSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/protocolrelation">
                    <ProtocolRelationSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/configuration/protocoloptions">
                    <ProtocolOptionsSearchMainQueryRenderer/>
                </Route>
                <Route path="/manager/offers">
                    <OfferSearchMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={() => {
                        }}
                    />
                </Route>
                <Route path="/manager/configuration/ORMOffers">
                    <ORMOfferSearchMainQueryRenderer
                        isOpenAsPopup={false}
                        handleClose={() => {
                        }}
                    />
                </Route>
                <Route path="/manager">
                    <Redirect to={"/manager/disposition"}/>
                </Route>
            </Switch>
        );
    };

    return (
        <>
            <ReactResizeDetector handleWidth handleHeight>
                {({width, height}) => (
                    <Container
                        fixed
                        id="content-container"
                        className={classes.container}
                        style={{
                            paddingLeft: sidebarIsOpen
                                ? DRAWER_WIDTH + 6
                                : DRAWER_WIDTH_CLOSED + 6,
                            overflow: "hidden",
                        }}
                    >
                        <React.Suspense fallback={<LoadingElement/>}>
                            {renderRoutes(width)}
                        </React.Suspense>
                    </Container>
                )}
            </ReactResizeDetector>
        </>
    );
}
